import c from "./TableContainer.module.scss";
import Pagination from "../utils/Pagination";
import Table from "../utils/table/Table";
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import debounce from "lodash.debounce";
import LoadingBox from "../loading/LoadingBox";
import useLoadingHelper from "../../hooks/loading.hook";
import EmptyBox from "../emptystate/EmptyBox";
import { getListTemplatesPlansContentPresets } from "../../services/plans-template-content-preset.service";
import MoreOptions from "../utils/more-options/MoreOptions";

const defaultFilters = {
	page: 1,
	filter: {
		title: "",
	},
};

function TablePresetContents({
	plan,
	handleEdit,
	handleCreate,
	handleCopy,
	handleDelete,
	forceUpdate,
	onListUpdate = () => {},
}) {
	const { queueLoading, addQueue, removeQueue, initStatus, setInitStatus } = useLoadingHelper();
	const navigate = useNavigate();

	const [contentPresets, setContentPresets] = useState([]);

	const [queryParams, setQueryParams] = useState(defaultFilters);

	const [pageData, setPageData] = useState({
		last: 0,
		current: 0,
		total: 0,
	});

	/**
	 * Fetch data
	 */
	useEffect(() => {
		getListContentPresets();
	}, [queryParams, forceUpdate]);

	/**
	 * Get List template contents preset
	 */
	const getListContentPresets = () => {
		const body = {
			...(plan && { templatePlan: plan.id }),
			...queryParams,
		};

		addQueue();

		// Fetch Api
		getListTemplatesPlansContentPresets(
			body,
			(res) => {
				setContentPresets(res.data);

				onListUpdate(res.data);

				removeQueue();

				setInitStatus(true);

				setPageData({
					last: res.meta.last_page,
					current: res.meta.current_page,
					total: res.meta.total,
				});
			},
			() => {
				removeQueue();
			}
		);
	};

	/**
	 * Update page
	 * @param {*} newPage
	 * @returns
	 */
	const updatePage = (newPage) => setQueryParams((q) => ({ ...q, page: newPage }));

	/**
	 * Debounce Search
	 */
	const debouncedSearch = debounce(onSearch, 300);

	/**
	 * Search event function
	 */
	function onSearch(e) {
		const searchModel = e.target.value;

		if (searchModel.trim().length > 0 || queryParams.filter.title != null) {
			setQueryParams((q) => ({
				...q,
				page: 1,
				filter: {
					...q.filter,
					title: searchModel.trim().length > 0 ? searchModel : "",
				},
			}));
		}
	}

	return (
		<>
			<div className={c.main_intro}>
				<div className={c.left_content}></div>
				<div className={c.right_content}>
					<div className="wrap_input_landing icon">
						<input
							type="text"
							onChange={debouncedSearch}
							className="landing"
							placeholder="Ricerca..."
						/>
						<span className="icon_16 default search"></span>
					</div>
					<button
						className="button fill primary small"
						onClick={() => handleCreate()}
						type="button"
					>
						<div className="load_content">Nuovo</div>
					</button>
				</div>
			</div>

			<div className="relative">
				{contentPresets.length > 0 ? (
					<div className="fade_in">
						<Table>
							{/* Table Head */}
							<Table.Head>
								<Table.Column>Titolo</Table.Column>
								<Table.Column>Descrizione</Table.Column>
								<Table.Column>Tipologia</Table.Column>
								<Table.Column>Attivo</Table.Column>
								<Table.Column></Table.Column>
							</Table.Head>

							{/* Table Body */}
							<Table.Body>
								{contentPresets.map((el, index) => (
									<Table.Row key={index}>
										<Table.Cell width={""}>
											<div className={"flex gap-2 items-center"}>{el.title}</div>
										</Table.Cell>

										<Table.Cell width={""}>
											<div className={"line-clamp-1"}>{el?.description ?? "-"}</div>
										</Table.Cell>

										<Table.Cell width={""}>{el.organization_type.name}</Table.Cell>

										<Table.Cell width={150}>
											<div className="main_icon_text">
												<span
													className={
														"icon_16 default icon_mask " +
														(el.active ? "check !bg-green-100" : "cross !bg-red-100")
													}
												/>
												{el.active ? "Si" : "No"}
											</div>
										</Table.Cell>

										<Table.Cell width={10}>
											<div className="spacing_items">
												<MoreOptions
													options={[
														{
															label: "Applica contenuti",
															icon: "icon_16 icon_mask !bg-interactive-100 default settings",
															onClick: () =>
																navigate(
																	`/admin/plans/templates/${plan.id}/content-presets/${el.id}/copy`
																),
														},
														{
															label: "Modifica",
															icon: "icon_16 icon_mask !bg-interactive-100 default edit",
															onClick: () => handleEdit(el.id),
														},
														{
															label: "Duplica preset",
															icon: "icon_16 icon_mask !bg-interactive-100 default duplicate",
															onClick: () => handleCopy(el.id),
														},
														{
															label: "Elimina",
															icon: "icon_16 icon_mask !bg-interactive-100 default delete",
															onClick: () => handleDelete(el.id),
														},
													]}
												/>
											</div>
										</Table.Cell>

										<Table.Cell width={1}>
											<div className="spacing_items">
												<Link
													to={`/admin/plans/templates/${plan.id}/content-presets/${el.id}/compile`}
													className="button fill tertiary x_small whitespace-nowrap"
												>
													Gestione contenuti
												</Link>
											</div>
										</Table.Cell>
									</Table.Row>
								))}
							</Table.Body>
						</Table>

						{/* Paginator */}
						<Pagination
							last={pageData.last}
							current={pageData.current}
							total={pageData.total}
							onChange={updatePage}
						/>
					</div>
				) : (
					initStatus && (
						<EmptyBox
							icon="icon_75 default archive_entity"
							title="Nessun risultato trovato"
							description="Qui visualizzerai la lista di tutti i preset del piano"
						/>
					)
				)}
				{queueLoading.length > 0 && <LoadingBox blocked={!initStatus} />}
			</div>
		</>
	);
}

export default TablePresetContents;
